import { mapMutations, mapGetters } from 'vuex'

let series_number_to_title = (num) => {
    switch(num) {
    case '08': return '建築物、土木設施與遺址'
    case '01': return '公文類'
    case '04': return '影像'
    case '02': return '圖說(技術文件)'
    case '03': return '出版品'
    case '07': return '文化、自然景觀類'
    case '06': return '口述歷史類'
    case '05': return '文物器具類'
    default: return '(未知的類別)'
    }
}


export default {
    computed: {
        ...mapGetters('frontstage_search', [
            'frontstage_search_keyword',
            'frontstage_filter_series_number',
            'frontstage_filter_series_title'
        ])
    },
    data () {
        return {
            collection_links: [
                {
                    title: '建築物、土木設施與遺址',
                    style: 'fa-building',
                    series_number: '08'
                },
                {
                    title: '公文類',
                    style: 'fa-folder',
                    series_number: '01'
                },
                {
                    title: '影像',
                    style: 'fa-images',
                    series_number: '04'
                },
                {
                    title: '圖說(技術文件)',
                    style: 'fa-file-alt',
                    series_number: '02'
                },
                {
                    title: '出版品',
                    style: 'fa-book-open',
                    series_number: '03'
                },
                {
                    title: '文化、自然景觀類',
                    style: 'fa-mountain',
                    series_number: '07'
                },
                {
                    title: '口述歷史類',
                    style: 'fa-user',
                    series_number: '06'
                },
                {
                    title: '文物器具類',
                    style: 'fa-hammer',
                    series_number: '05'
                },
            ]
        }
    },
    methods: {
        ...mapMutations('frontstage_search', [
            'mutation_frontstage_search_keyword',
            'mutation_frontstage_filter_series_number',
            'mutation_frontstage_filter_series_title'
        ]),
        update_frontstage_search_keyword(keyword) {
            this.mutation_frontstage_search_keyword(keyword)
        },
        clear_frontstage_search_keyword () {
            this.mutation_frontstage_search_keyword(null)
        },
        update_frontstage_filter_series_number(series_number) {
            this.mutation_frontstage_filter_series_number(series_number)
            this.mutation_frontstage_filter_series_title(series_number_to_title(series_number))
        },
        clear_frontstage_filter_series_number () {
            this.mutation_frontstage_filter_series_number(null)
            this.mutation_frontstage_filter_series_title(null)
        },
    },
}